<template>
  <el-button
    class="btn-text can-hover p-0"
    type="text"
    v-b-toggle.sidebar-backdrop
  >
    <span class="d-flex align-items-center">
      <span class="text-white mr-3">
        Hi,
        <span class="font-weight-bold">{{ userName }}</span>
      </span>
      <el-avatar :size="30" :src="info.avatar || defaultAvatar" style="outline:none;">
        <img :src="defaultAvatar" />
      </el-avatar>
    </span>
  </el-button>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      defaultAvatar: `${this.$baseUrl}image/theme/default/avatar.png`,
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
    userName() {
      return (this.info && this.info.userName) || ''
    },
  },
}
</script>
